import React from 'react';
import { StyledTooltip } from '../StyledTooltip';
import { ReactChildrenType } from 'types/global';
import { HintIcon } from 'modules/ui/Hint/styles';

interface HintProps {
  children: ReactChildrenType;
}

export const Hint: React.FC<HintProps> = ({ children }) => (
  <StyledTooltip title={children}>
    <HintIcon />
  </StyledTooltip>
);
